import React, { Component } from "react";
import Marketplace from "./Marketplace";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  PROJECTS,
  LAYOUTS,
  MY_ASSETS,
  MY_TEMPLATES,
  MY_COMPONENTS,
  QUICK_START,
  MY_FOLDERS,
  TEMPLATES_SCREEN,
  MY_COPIES,
  MAGICAL,
  AI_TEMPLATE_PATH,
  AI_NEW_DOCUMENT,
  TEMPLATES_BY_FORMAT_SCREEN_PATH,
  DOCUMENTS,
  TEMPLATES_BY_CATEGORY_SCREEN_PATH,
  PUBLISHING,
  PLANNER,
  ANALYTICS,
  DRAFT,
  POST,
  SEARCH_TEMPLATES_SCREEN,
  ALL_TEMPLATES_BY_FORMAT_PATH,
  MY_PROJECTS,
  SHARED_WITH_ME_PROJECTS,
  MY_DOCUMENTS,
  SHARED_WITH_ME_DOCUMENTS,
  FAVORITES,
  FOLDER_CONTENTS_PATH,
  TEAM_TEMPLATES,
  SHARED_WITH_ME_TEMPLATES,
  SEARCH_TEMPLATES_BY_FORMAT_SCREEN_PATH,
  AI_WRITER_SCREEN_PATH,
  AI_SHORT,
  AI_SHORT_FORM_ALL,
} from "../_utils/routes";
import TldrHomeBase from "./TldrHomeBase";
import { Redirect } from "react-router-dom";
import { isEmpty } from "lodash";
import { wsConnect, wsDisconnect } from "../_actions/webSocketAction";
import axios from "axios";
import { WEBSOCKETS_NOTIFICATIONS_ENDPOINT, WEBSOCKETS_USER_NOTIFICATIONS_ENDPOINT } from "../_actions/endpoints";
import Format from "string-format";
import { getAuthToken } from "../_utils/common";
import TldrSelectWorkspaceModal from "../_components/common/TldrSelectWorkspaceModal";

export class Home extends Component {
  signal = axios.CancelToken.source();
  constructor(props) {
    super(props);
    this.state = {
      isWorkspaceModalOpen: false,
    };
    this.onCloseWorkspaceModal = this.onCloseWorkspaceModal.bind(this);
  }

  UNSAFE_componentWillMount() {
    const planName = localStorage.getItem("planName");
    if (planName) this.setState({ isWorkspaceModalOpen: true });
  }

  componentDidMount() {
    this.fetchUserNotifications();
  }

  componentWillUnmount() {
    this.props.wsDisconnect();
    this.signal.cancel("The user aborted a request.");
  }

  fetchUserNotifications = () => {
    const { pk } = this.props.user;
    const token = getAuthToken();
    if (token) {
      var dev = Format(WEBSOCKETS_USER_NOTIFICATIONS_ENDPOINT, pk, token);
      this.props.wsConnect(dev);
    }
  };

  getSelectedTab() {
    const { path } = this.props.match;
    let selectedTab = "quick_start";
    switch (path) {
      case PROJECTS:
        selectedTab = "projects";
        break;
      case MY_PROJECTS:
        selectedTab = "my_projects";
        break;
      case SHARED_WITH_ME_PROJECTS:
        selectedTab = "shared_with_me_projects";
        break;
      case QUICK_START:
        selectedTab = "quick_start";
        break;
      case LAYOUTS:
        selectedTab = "layouts";
        break;
      case MY_ASSETS:
        selectedTab = "assets";
        break;
      case TEAM_TEMPLATES:
        selectedTab = "team_templates";
        break;
      case MY_TEMPLATES:
        selectedTab = "my_templates";
        break;
      case SHARED_WITH_ME_TEMPLATES:
        selectedTab = "shared_with_me_templates";
        break;
      case MY_COMPONENTS:
        selectedTab = "my_components";
        break;
      case MY_FOLDERS:
        selectedTab = "my_folders";
        break;
      case SEARCH_TEMPLATES_SCREEN:
      case SEARCH_TEMPLATES_BY_FORMAT_SCREEN_PATH:
        selectedTab = "search_templates";
        break;
      case ALL_TEMPLATES_BY_FORMAT_PATH:
      case TEMPLATES_SCREEN:
        selectedTab = "templates_screen";
        break;
      case TEMPLATES_BY_CATEGORY_SCREEN_PATH:
      case TEMPLATES_BY_FORMAT_SCREEN_PATH:
        selectedTab = "templates_by_format";
        break;
      case MY_COPIES:
        selectedTab = "saved_copies";
        break;
      case MAGICAL:
        selectedTab = "ai";
        break;
      case AI_TEMPLATE_PATH:
        selectedTab = "ai_document";
        break;
      case AI_NEW_DOCUMENT:
        selectedTab = "ai_new";
        break;
      case DOCUMENTS:
        selectedTab = "documents";
        break;
      case PUBLISHING:
        selectedTab = "publishing";
        break;
      case PLANNER:
        selectedTab = "planner";
        break;
      case ANALYTICS:
        selectedTab = "analytics";
        break;
      case POST:
        selectedTab = "post";
        break;
      case DRAFT:
        selectedTab = "draft";
        break;
      case MY_DOCUMENTS:
        selectedTab = "my_documents";
        break;
      case SHARED_WITH_ME_DOCUMENTS:
        selectedTab = "shared_with_me_documents";
        break;
      case FAVORITES:
        selectedTab = "favorites";
        break;
      case FOLDER_CONTENTS_PATH:
        selectedTab = "folder_contents";
        break;
      case AI_WRITER_SCREEN_PATH:
        selectedTab = "ai_input_form";
        break;
        case AI_SHORT:
        case AI_SHORT_FORM_ALL:
        selectedTab = "ai_short_form_panel";
        break;
      default:
        selectedTab = "quick_start";
        break;
    }
    return selectedTab;
  }

  onCloseWorkspaceModal() {
    localStorage.removeItem("planName");
    localStorage.removeItem("promoCode");
    this.setState({ isWorkspaceModalOpen: false });
  }

  render() {
    const { workspacePermissionChecks } = this.props;
    const { path } = this.props.match;
    const { isWorkspaceModalOpen } = this.state;
    let selectedTab = this.getSelectedTab();
    let selectedView = null;
    const { canViewMyLibrary, canCreateStory } = workspacePermissionChecks;
    switch (selectedTab) {
      case "ai_document":
        const {
          params: { promptId },
        } = this.props.match;
        selectedView = (
          <Marketplace path={selectedTab} key={promptId} extras={promptId} />
        );
        break;
      default:
        selectedView = <Marketplace path={selectedTab} key={selectedTab} />;
        if (
          !canViewMyLibrary &&
          (selectedTab === "my_folders" ||
            selectedTab === "assets" ||
            selectedTab === "my_templates" ||
            selectedTab === "my_components"
           
            )
        ) {
          selectedView = null;
        }
        if (!canCreateStory && selectedTab === "layouts") {
          selectedView = null;
        }
    }

    return (
      <TldrHomeBase
        hidesidebar={
          path === SEARCH_TEMPLATES_SCREEN ||
          path === SEARCH_TEMPLATES_BY_FORMAT_SCREEN_PATH
        }
        {...this.props}
      >
        {selectedView
          ? selectedView
          : !isEmpty(workspacePermissionChecks) && <Redirect to="/403" />}
        {isWorkspaceModalOpen && (
          <TldrSelectWorkspaceModal
            isOpen={isWorkspaceModalOpen}
            onClose={this.onCloseWorkspaceModal}
          />
        )}
      </TldrHomeBase>
    );
  }
}

Home.propTypes = {
  errors: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  wsConnect: (url) => dispatch(wsConnect(url)),
  wsDisconnect: () => dispatch(wsDisconnect()),
});

const mapStateToProps = (state) => ({
  errors: state.errors,
  workspacePermissionChecks: state.permissions.workspacePermissionChecks,
  user: state.auth.payload.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
